import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import type { DashboardData } from '../../../services/dashboard.service';
import { formatDashboardCurrency } from '../dashboard-utils';

@Component({
  selector: 'app-dash-collection-breakdown',
  templateUrl: './dash-collection-breakdown.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ChartModule],
  styles: [':host { display: block; height: 100%; }']
})
export class DashCollectionBreakdownWidgetComponent {
  data = input<DashboardData | null>(null);

  readonly formatCurrency = formatDashboardCurrency;

  readonly chartData = computed(() => {
    const d = this.data();
    const paid = d?.rates?.totalPaid ?? 0;
    const pending = d?.rates?.totalPending ?? 0;
    return {
      labels: ['Cobrado', 'Pendiente'],
      datasets: [
        {
          label: 'Monto',
          data: [paid, pending],
          backgroundColor: ['#10b981', '#f59e0b'],
          borderWidth: 0
        }
      ]
    };
  });

  readonly chartOptions = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { x: { beginAtZero: true } }
  };

  readonly combinedTotal = computed(() => {
    const d = this.data();
    return (d?.rates?.totalPaid ?? 0) + (d?.rates?.totalPending ?? 0);
  });
}
